import { Container, Input } from 'components/atoms';
import { AddressForm, FormInput } from 'components/molecules';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiBank, PiUser } from 'react-icons/pi';
import { IAccountMutationForm } from 'services/accounts/types';
import { useGetCountries } from 'services/enums';
import { getCountriesPhoneNumberPrefixOptionValues } from 'utils/global/countries.utils';

const LabelFinances = () => {
  const { values } = useFormikContext<IAccountMutationForm>();
  const { t } = useTranslation();

  const countries = useGetCountries();

  const countryOptions =
    countries.data?.map(country => ({
      label: country.englishName,
      value: country.codeAlfa2,
    })) ?? [];

  return (
    <div className='flex gap-6 justify-start w-full'>
      <Container className='self-start w-full max-w-[350px]'>
        <Container.Header
          title={
            <>
              <PiUser /> {t('label.personal-data.header')}
            </>
          }
        />
        <Container.Content>
          <div className='flex flex-col w-full gap-3'>
            <FormInput.Text
              name='firstName'
              label={t('input.label.firstName')}
            />
            <FormInput.Text name='lastName' label={t('input.label.lastName')} />
            <FormInput.Text name='name' label={t('input.label.name')} />
            <FormInput.Text name='fullName' label={t('input.label.fullName')} />
            <FormInput.Text
              name='email'
              label={t('input.label.email')}
              type='email'
            />
            <Input.ComplexWrapper sizes={[40, 60]}>
              <FormInput.Select
                name='phoneNumberPrefix'
                label={t('input.label.phoneNumberCodeShort')}
                isCreatable
                options={getCountriesPhoneNumberPrefixOptionValues()}
              />
              <FormInput.Text
                name='phoneNumber'
                label={t('input.label.phoneNumber')}
              />
            </Input.ComplexWrapper>
          </div>
        </Container.Content>
      </Container>
      <AddressForm propertyPrefix='address.' />
      <AddressForm
        propertyPrefix='taxOffice.'
        title={t('label.tax-office.address')}
        topContent={
          <Container.Content>
            <FormInput.Text
              name={`taxOffice.name`}
              label={t('input.label.name')}
              wrapperClassName='max-w-80'
            />
          </Container.Content>
        }
      />
      <Container className='self-start w-full max-w-[350px]'>
        <Container.Header
          title={
            <>
              <PiBank /> {t('label.accounting.header')}
            </>
          }
        />
        <Container.Content>
          <div className='flex flex-col w-full gap-3'>
            <FormInput.Select
              name={'companyCountryAlfa2'}
              label={t('input.label.country')}
              options={countryOptions}
              isLoading={countries.isLoading}
            />
            <FormInput.Text
              name='companyId'
              label={t('input.label.companyId')}
            />
            <FormInput.Text
              name='bankAccountNumber'
              label={t('input.label.bankAccountNumber')}
            />
            <FormInput.Text name='bankName' label={t('input.label.bankName')} />
            <FormInput.Text name='swift' label={t('input.label.swift')} />
          </div>
        </Container.Content>
      </Container>
    </div>
  );
};

export default LabelFinances;
